import Radio from '@mui/joy/Radio';

export default function RadioButtonLabel() {
  return <Radio label="Text" defaultChecked />;
}
